import React, { Component } from 'react'
import Typography from "@mui/material/Typography";
import TransactionList from "./transactionList";
import { Divider } from '@mui/material';
import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";

export class TransactionScreen extends Component {

    state = { transactions: this.props.transactions ? this.props.transactions : {} };

    render() {
        return (
            <Card className="widgetCard cardShadow popup" id="child_TransactionScreen">
                <Box className="popupClose">
                <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
            <ArrowBackIcon />
            </IconButton>
        </Box>

        <CardContent textAlign="center">
            <Box className="popupHeader">
                <Typography  sx={{ fontWeight: 700 }} variant="h4" align="center">
                    All Transactions
                </Typography>                
                <Divider sx={{marginBottom:"1rem"}} variant="light"/>
                </Box>
                <Box className="popupBody" pt={{xs:10,sm:0}}>
                {
                    this.state.transactions? <TransactionList
                    heading={
                        this.state.transactions.committed.heading
                    }
                    transactionStatus={
                        this.props.from_weekly_spends ? this.props.transactionStatus : this.state.transactions.committed.transactionStatus
                    }
                    transactionDetails={this.state.transactions.committed
                        .transactionDetails
                    }
                    prefix={this.props.prefix}
                />
                :
                <Typography
                variant="body"
                color="text.secondary"
                align="center"
                
                gutterBottom
            >
                No transactions to show
            </Typography>
                }
                </Box>
                </CardContent>
            </Card>
        )
    }
}

export default TransactionScreen
